import { render } from "./WaspsList.vue?vue&type=template&id=938faf08"
import script from "./WaspsList.vue?vue&type=script&lang=js"
export * from "./WaspsList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__